import type { ElementType, ReactNode } from "react"
import classNames from "classnames"
import { AppBar } from "@mui/material"
import LogoHomeLink from "components/logo/home-link"
import ServerNotifications from "modules/server-notifications"
import HelpMenu from "modules/help-menu"
import ThemeModeToggle from "components/theme-mode-toggle"
import { KellyLauncherButton } from "connected-components/agent-chat/components/kelly-launcher-button"

interface Props {
  account: string
  Icon?: ElementType | null
  title?: string
  children?: ReactNode
  className?: string
  modelId?: string | null
  // Shells that must intercept the logo navigation — an unsaved-upload prompt — pass this.
  onLogoClick?: () => void
  actions?: ReactNode
  noShadow?: boolean
}

export default function HomeHeader({ account, Icon = null, title = "", children, className, modelId, onLogoClick, actions, noShadow }: Props) {
  return <AppBar position="sticky" elevation={noShadow ? 0 : undefined} className={classNames(className, { "no-shadow": noShadow })}>
    <div className="header-app-bar">
      <div className="left">
        <LogoHomeLink account={account} onClick={onLogoClick} />
        {Icon && <Icon />}
        {title && <span className="title">{title}</span>}
        {children}
      </div>
      <div className="right">
        {actions && <div className="header-app-actions">
          <div className="header-app-action">{actions}</div>
        </div>}
        <ServerNotifications />
        <HelpMenu modelId={modelId} />
        <ThemeModeToggle inline />
        <KellyLauncherButton />
      </div>
    </div>
  </AppBar>
}
